import { SvgIcon } from '@mui/material';

const Phone = () => {
  return (
    <SvgIcon
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 16, height: 17, fill: 'none' }}
      data-testid="phoneIcon"
    >
      <path
        d="M14.5099 12.5169L13.0309 11.3273L11.6816 10.2785C11.4174 10.0704 11.1197 10.0633 10.9048 10.2785L9.77067 11.4144C8.88787 12.2985 7.85487 11.7764 6.29592 10.2185C4.73698 8.66056 4.21837 7.62335 5.10187 6.73851L6.23602 5.60266C6.45086 5.38749 6.39774 5.06511 6.23602 4.82473L5.12041 3.38172L4.00491 1.99439C3.79006 1.77921 3.443 1.77921 3.22815 1.99439C2.76744 2.39414 1.91225 3.01364 1.5998 3.62862C0.707357 5.38517 2.11466 8.73712 4.9428 11.5695C7.773 14.404 11.1198 15.792 12.8716 14.8961C13.4991 14.537 14.022 13.7669 14.4994 13.2888C14.7184 13.0737 14.7227 12.7321 14.5099 12.5169Z"
        fill="#4D5160"
      />
    </SvgIcon>
  );
};

export default Phone;
